var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSkipLeftCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4999 23.8334L17.4999 18.0007C17.5001 18.2311 17.595 18.4614 17.7845 18.6272L24.4512 24.4606C24.99 24.932 25.8333 24.5494 25.8333 23.8334L25.8333 12.1667C25.8333 11.4508 24.99 11.0681 24.4512 11.5396L17.7845 17.3729C17.595 17.5388 17.5001 17.7691 17.4999 17.9994L17.4999 12.1667C17.4999 11.4508 16.6566 11.0681 16.1178 11.5396L9.45116 17.3729C9.07172 17.7049 9.07172 18.2952 9.45116 18.6272L16.1178 24.4606C16.6566 24.932 17.4999 24.5494 17.4999 23.8334ZM19.5987 18L24.1666 21.9969L24.1666 14.0032L19.5987 18ZM15.8332 14.0032L11.2654 18L15.8333 21.9969L15.8332 14.0032Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSkipLeftCircle);
export default __webpack_public_path__ + "static/media/icon_skip_left_circle.9af01e29.svg";
export { ForwardRef as ReactComponent };